export default "__VITE_ASSET__3_V9wA4Q__"